import { cn } from '@/utils';
import { buttonVariants } from '@/components/ui/button';
import { useMemo } from 'react';

const Day = ({
  date,
  displayMonth,
  handleSelect,
  availabilities,
  isPublicView
}) => {
  const isToday = new Date().toDateString() === date.toDateString();
  const isPast = date < new Date(new Date().setHours(0, 0, 0, 0));

  // Memoize the availability check
  const hasAvailability = useMemo(() => {
    if (!availabilities) {
      return false;
    }

    return availabilities.some((availability) => {
      const startDate = new Date(availability.startDateTime);
      const endDate = new Date(availability.endDateTime);
      const currentDate = new Date(date.setHours(0, 0, 0, 0));

      return (
        currentDate >= new Date(startDate.setHours(0, 0, 0, 0)) &&
        currentDate <= new Date(endDate.setHours(0, 0, 0, 0))
      );
    });
  }, [availabilities, date]);

  return (
    <button
      // eslint-disable-next-line react/no-unknown-property
      displaymonth={displayMonth}
      className={cn(
        buttonVariants({ variant: 'ghost' }),
        'h-9 w-9 p-0 font-normal aria-selected:opacity-100 relative',
        isToday && 'border-2 border-secondary',
        isPast && 'text-muted-foreground'
      )}
      onClick={() => (!isPast || !isPublicView) && handleSelect(date)}
    >
      {date.getDate()}
      {hasAvailability && (
        <div className="absolute bottom-1 left-1/2 -translate-x-1/2 w-1 h-1 bg-blue-500 rounded-full" />
      )}
    </button>
  );
};

export default Day;
